import React from "react";
import {Container, Header, Icon } from "semantic-ui-react";
import AppListPage from "../../common/AppListPage";
import {
    SurveySessionListOptions,
    SurveySessionModel,
    SurveySessionState,
    SurveySessionStateToString
} from "../model/SurveySessionModel";
import {SurveySessionDataProvider} from "../service/SurveySessionDataProvider";
import {getPatientTitle, PatientTitleCase} from "../../../utils/common";
import {ColumnFormat, DataGridSelection} from "../../common/AppListDataGrid";
import SurveySessionDetails from "./SurveySessionDetails";
import styles from "./index.module.css";
import {TaskModel} from "../../workTableTask/TaskModel";
import CreatedTaskDetailsModal from "../../workTablePatients/CreatedTaskDetailsModal";
import {hasRole, UserRole} from "../../../helpers/UserRole";

interface Props {
}

const SurveyResultList = (props: Props) => {

    const [selection, setSelection] = React.useState<DataGridSelection | undefined>();
    const [filter, setFilter] = React.useState<any | undefined>();
    const [sort, setSort] = React.useState<string | undefined>();
    const [createdTask, setCreatedTask] = React.useState<TaskModel | undefined>();

    const provider = new SurveySessionDataProvider();

    function getStateClassName(state: SurveySessionState) {
        switch (state) {
            case SurveySessionState.pending:
                return styles.cell_state_pending;
            case SurveySessionState.executing:
                return styles.cell_state_executing;
            case SurveySessionState.completed:
                return styles.cell_state_completed;
            case SurveySessionState.cancelled:
                return styles.cell_state_cancelled;
            case SurveySessionState.error:
                return styles.cell_state_error;
        }
    }

    async function handleButtonClick(button: string) {
        if (button === 'export') {
            const res = await provider.createExportTask(
                {
                    selectedIds:
                        selection?.mode == 'ids' && selection?.selectedIds && selection.selectedIds.length > 0 ?
                            selection?.selectedIds : undefined,
                    ...filter,
                    sort
                });
            setCreatedTask(res.task);
        }
    }

    return <Container fluid>
        {createdTask && <CreatedTaskDetailsModal task={createdTask}
                                                 onClose={() => setCreatedTask(undefined)}/>}
        <Header attached> <Icon name="tasks"/>Ответы</Header>
        <AppListPage<SurveySessionModel, SurveySessionListOptions>
            provider={provider}
            menuButtons={
                [
                    {
                        key: "view",
                        name: "Просмотр",
                        icon: "zoom",
                        iconColor: "blue"
                    },
                    {
                        key: "export",
                        name: "Экспорт",
                        icon: "download" ,
                        iconColor: "teal",
                        hidden: !hasRole(UserRole.ADMIN)
                    },
                    {
                        key: "refresh",
                        icon: "refresh",
                        iconColor: "violet",
                        alignRight: true
                    },
                ]}

            getDetailsComponent={(context) => <SurveySessionDetails context={context}/>}
            multiSelect={true}
            onSelectionChanged={(selection) => {
                setSelection(selection)
            }}
            onButtonClick={handleButtonClick}
            onFilterChanged={setFilter}
            onSortChanged={setSort}
            columns={[
                {key: "patientName", name: getPatientTitle(PatientTitleCase.imUp), filterable: true},
                {key: "campaignName", name: "Кампания", filterable: true},
                {
                    key: "state", name: "Состояние", accessor: (x) => SurveySessionStateToString(x.state),
                    width: 150,
                    filterable: true,
                    filterableOptions: {
                        dropdownItems: Object.values(SurveySessionState)
                            .map((x: SurveySessionState) => ({
                                value: x,
                                text: SurveySessionStateToString(x),
                                className: getStateClassName(x)
                            }))
                    },
                    cellClass: (item) => getStateClassName(item.state)
                },
                {
                    key: "createdAt", name: "Создано", format: ColumnFormat.datetime, sortDirection: 'DESC', width: 180,
                    cellClass: () => styles.cell_text_align_center,
                },
                {
                    key: "startedAt", name: "Время начала", format: ColumnFormat.datetime, width: 160,
                    cellClass: () => styles.cell_text_align_center,
                },
                {
                    key: "finishedAt", name: "Время окончания", format: ColumnFormat.datetime, width: 160,
                    cellClass: () => styles.cell_text_align_center,
                },
            ]}
        />
    </Container>;
}

export default SurveyResultList;